import { render, staticRenderFns } from "./OrganizationCreateModalWrapper.vue?vue&type=template&id=7ebab525"
import script from "./OrganizationCreateModalWrapper.vue?vue&type=script&lang=ts"
export * from "./OrganizationCreateModalWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports